export default "__VITE_ASSET__CxKangu1__"